// extracted by mini-css-extract-plugin
export default {"container":"EPDHw","dot":"k2COz","opacitychange":"L2jOR"};